import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.364"
    }, [
      _createElementVNode("path", {
        "stroke-linejoin": "round",
        d: "M7.3 10H19m0 0-3.15-2.7M19 10l-3.15 2.701"
      }),
      _createElementVNode("path", { d: "M12.698 5.5c-.01-1.957-.097-3.018-.789-3.71C11.12 1 9.846 1 7.3 1h-.9c-2.545 0-3.818 0-4.61.79C1 2.583 1 3.856 1 6.4v7.201c0 2.546 0 3.819.79 4.61.692.691 1.753.778 3.71.789m7.198-4.499c-.01 1.958-.097 3.018-.789 3.71-.577.577-1.41.733-2.809.775" })
    ], -1)
  ]))]))
}
export default { render: render }